import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Loremo",
  "description": "",
  "published": "2007-03-07T00:00:00.000Z",
  "redirect_from": ["/blog/the-loremo/swizec/271"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A lot of people are saying that this is a silly car, that it's too small, too unpretty, looks cheap and what have you. But I find the`}<a parentName="p" {...{
        "href": "http://loremo.com/"
      }}>{` Loremo`}</a>{` to be a rather interesting little car. Of course it's not what you normally see on the road and it's far from being aesthetically pleasing to those who only like the sporty look, but that's alright, it wasn't meant to be that, it's meant to be an efficient little futuristic vehicle.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      